<ng-container>
  <ng-container>
    <button
      mat-icon-button
      data-automation-id="smt-action-button-show-filter-header"
      (click)="showHideFiltersHeaderTable()"
      [attr.aria-label]="'ALDEN.ACTIONS.SHOW_FILTER_HEADER' | translate"
      [attr.title]="'ALDEN.ACTIONS.SHOW_FILTER_HEADER' | translate"
    >
      <mat-icon fontSet="material-icons-outlined">filter_alt</mat-icon>
    </button>
  </ng-container>
</ng-container>

<ng-template>
  <span>{{ 'ALDEN.ACTIONS.SHOW_FILTER_HEADER' | translate }}</span>
</ng-template>
